import { useSuspenseQuery } from '@tanstack/react-query';
import type { Element, ItemCollectibleVariant } from '@outdoria/types';
import { fetcher } from '../utils';
import { COLLECTIBLE_VARIANT } from '../queryKeys';

type Data = (ItemCollectibleVariant & { elements: Element['element_id'][] })[];
export const useAdminGetAllVariantsByCollectibleId = (
  item_id: string | null,
) => {
  const queryFn = async (): Promise<Data> => {
    if (item_id === null) return [];
    const res = await fetcher(`/v2/admin/items/${item_id}/variants`);
    return res.json();
  };

  const {
    data = [],
    isLoading,
    isFetched,
    isError,
  } = useSuspenseQuery<Data, unknown, Data, string[]>({
    queryKey: [...COLLECTIBLE_VARIANT, item_id!],
    queryFn,
  });

  return { data, isLoading, isFetched, isError };
};
